import apiUrl from '../../../../constants'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker'

//import vueSpinner from 'vue-spinner'
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

import {
	Validator
} from 'vee-validate'

export default {
	name: 'grc',
	components: {
		DatePicker
	},
	props: [],
	data() {
		return {
			srQcInput: {
				AWBNo: '',
				productid: '',
				mrp: '',
				expiryDate: '',
				manufacturedDate: '',
				shelflife: '',
				lotNumber: '',
				qualityCheck: '',
				comment: '',
				lpnid: '',
				rejectreason: '',
				drnum: '',
				closelpn: false,
				couriername: '',
				rejectreasonother : '',
			},
			text: '',
			srQcDetails: {
				customername: '',
				orderid: '',
				couriercompany: '',
				srid: ''
			},
			srProductRes: {},
			isAwbFound: false,
			isProductFound: false,
			isExpiryControl: 0,
			isLotControl: false,
			AWBError: '',
			productError: '',
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin fa-2x" style="color:#1985ac"></i>',
			rightIcon: '<i class="fa fa-check" style="font-size:25px;color:green"></i>',
			wrongIcon: '<i class="fa fa-close" style="font-size:25px;color:red"></i>',
			productdescription: '',
			productimage: '',
			rejectList: [],
			reasonflag: false,
			useremail: '',
			clientData: [],
			mrpError: '',
			isProductAttrFound: false,
			ListMrpData: [],
			falsyProduct: false,
			finalproductid: 0,
			transporterList: [],
			couriernameerror: '',
			AWBNoerror: '',
			checkbutton: false,
			alwaysHide : false,

			showreasonother : false,
			rejectOtherError : false,
		}
	},
	computed: {
		isComplete() {
			return true;
		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetail = this.getLocalUserData();
		//this.warehouseid = userdetail[0].warehouseid;
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getTransporterList();
		}
		this.useremail = userdetail.email;
		this.todayDate = moment().format('DD/MM/YYYY');
		//this.showSearchDR('');
	},
	created() {},
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD hh:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		checkReason(){
			if(this.srQcInput.rejectreason == 'other')
			{
				 this.showreasonother = true;
			}
			else {
				this.rejectOtherError = '';
				this.showreasonother = false;
			}
		},
		getLocalUserData() {
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			return userdetail;
		},
		isNumeric: function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},
		searchAWBNo(e) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var code = (e.keyCode || e.which);
			// do nothing if it's an arrow key
			if (code == 37 || code == 38 || code == 39 || code == 40) {
				return;
			}
			if (this.srQcInput.AWBNo) {
				this.AWBError = '';
				this.isAwbFound = false;
				var inputs = {
					'warehouseid': this.warehouseid,
					'clientid': this.clientid,
					'awbno': this.srQcInput.AWBNo,
					'transporter' : this.srQcInput.couriername,
				}
				// axios.post(apiUrl.api_url + 'searchAWBNo', inputs,
				//     headers: {
				//       'Authorization': 'Bearer ' + myStr,
				//     }
				//   )
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'searchAWBNo',
						'data': inputs,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then((response) => {
						if (response.data.errorCode == 0) {
							document.getElementById("transporter").disabled = true;
							this.isAwbFound = true;
							var response = response.data.result[0];
							if (response.customerlastname == null)
								this.srQcDetails.customername = response.customerfirstname;
							else
								this.srQcDetails.customername = response.customerfirstname + " " + response.customerlastname;
							this.srQcDetails.orderid = response.orderid;
							this.srQcDetails.couriercompany = response.couriercompany;
							this.srQcDetails.srid = response.srid;
						} else {
							this.AWBError = response.data.msg;
							this.isAwbFound = false;
						}
					})
			}
		},

		resetform() {
			this.$validator.reset();
			this.checkbutton = false;
			this.srQcInput.AWBNo = '';
			document.getElementById("transporter").disabled = false;
			this.isAwbFound = false;
			this.isExpiryControl = 0;
			this.isProductFound = false;
			this.isLotControl = false;
			this.srQcInput.productid = '';
			this.srQcInput.mrp = '';
			this.srQcInput.shelflife = '';
			this.srQcInput.manufacturedDate = '';
			this.srQcInput.expiryDate = '';
			this.srQcInput.lotNumber = '';
			if(this.srQcInput.qualityCheck == "reject" && this.srQcInput.rejectreasonother!="")
			{
				 this.getElementByIdFn('rejectreasonother', '');
			}
			this.srQcInput.qualityCheck = '';
			this.srQcInput.rejectreason = '';
			this.srQcInput.couriername = '';
			this.srQcInput.comment = '';
			this.srQcInput.drnum = '';
			this.srQcInput.closelpn = false;
			this.isProductAttrFound = false;
			this.getElementByIdFn('AWBNo', '');


			this.text = ""
			this.srQcDetails.customername = "";
			this.srQcDetails.orderid = "";
			this.srQcDetails.couriercompany = "";
			this.srQcDetails.srid = "";
			this.srProductRes = {};
			this.isAwbFound = false;
			this.isProductFound = false;
			this.isExpiryControl = 0;
			this.isLotControl = false;
			this.AWBError = "";
			this.productError = "";
			this.loading = "";
			this.productdescription = '';
			this.productimage = '';
			this.rejectList = [];
			this.reasonflag = false;
			this.clientData = [];
			this.mrpError = '';
			this.isProductAttrFound = false;
			this.ListMrpData = [];
			this.falsyProduct = false;
			this.finalproductid = 0;
			this.couriernameerror = '';
			this.AWBNoerror = '';
			this.srQcInput.rejectreasonother = '';

		},


		searchAWBClientWareHouse(e) {
			this.AWBNoerror = ""
			this.couriernameerror = ""
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var code = (e.keyCode || e.which);
			if (code == 37 || code == 38 || code == 39 || code == 40) {
				return;
			}
			if (this.srQcInput.couriername == "") {
				this.couriernameerror = this.$t('srqc.transporterError')
				return false;
			}

			if (this.srQcInput.AWBNo == "") {
				this.AWBNoerror = this.$t('srqc.awbNumberError')
				return false;
			}
			if (this.srQcInput.AWBNo) {
				this.input = ({
					awbnumber: this.srQcInput.AWBNo,
					couriername: this.srQcInput.couriername
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getAWBClientSR',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						var resultCount = result.data.count;
						if (resultCount > 0) {
							this.checkbutton = true;
							this.clientData = result.data.rows;
							this.clientid = this.clientData[0].clientid;
							this.warehouseid = this.clientData[0].warehouseid;
							this.searchAWBNo(e);
						} else {
							this.AWBError = this.$t('srqc.invalidAwbError');
							this.isAwbFound = false;
						}
					}, error => {
						console.error(error)
					})
			}
		},

		searchProductSR(e) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var code = (e.keyCode || e.which);
			// do nothing if it's an arrow key
			if (code == 37 || code == 38 || code == 39 || code == 40) {
				return;
			}
			this.productError = "";
			this.isProductFound = false;
			if (this.srQcInput.productid != '' && this.srQcInput.productid.length > 2) {
				// if (this.isNumeric(this.srQcInput.productid) === false) {
				// 	this.productError = "Product id should be number only";
				// 	return;
				// }
				var inputs = {
					'warehouseid': this.warehouseid,
					'clientid': this.clientid,
					'awbno': this.srQcInput.AWBNo,
					'orderid': this.srQcDetails.orderid,
					'productid': this.srQcInput.productid,
					'srid' : this.srQcDetails.srid,
				}
				// axios.post(apiUrl.api_url + 'searchProductSR', inputs,
				//     headers: {
				//       'Authorization': 'Bearer ' + myStr,
				//     }
				//   )
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'searchProductSR',
						'data': inputs,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then((response) => {
						if ((response.data.errorCode == 0 || response.data.errorCode == -1) && response.data.result.length > 0) {
							this.productError = "";
							this.isProductFound = true;
							this.srProductRes = response.data.result[0];
							this.finalproductid = response.data.result[0].productid;
							this.isExpiryControl = this.srProductRes.isexpirycontrol;
							this.isExpiryControl = 0; //Doing Foe Disabling The LotControl
							this.isLotControl = this.srProductRes.islotcontrol;
							this.productdescription = this.srProductRes.productdescription;
							this.productimage = this.srProductRes.productimage;
							if (response.data.errorCode == -1) {
								this.productError = response.data.msg;
								this.falsyProduct = true;
							} else {
								this.falsyProduct = false;
							}
							this.getProductMrps();
							this.getProductAttr(e);
						} else {
							this.productError = response.data.msg;
							this.isProductFound = false;
						}
					});
			}
		},


		getTransporterList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'courierMasterList',
					'data': {},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.transporterList = result.data.data.rows;
				}, error => {
					console.error(error)
				})
		},

		getProductMrps() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var inputs = {
				'productid': this.srQcInput.productid,
				'clientid': this.clientid,
				'orderid' : this.srQcDetails.orderid,
			}
			// axios.post(apiUrl.api_url + 'getProductMrpSr', inputs,
			// headers: {
			//     'Authorization': 'Bearer ' + myStr,
			// }
			//  )
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductMrpSr',
					'data': inputs,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {

					if (response.data.errorCode == 0) {
						this.ListMrpData = response.data.data
					} else {
						this.productError = response.data.msg;
						this.isProductFound = false;
					}
				});
		},

		getProductAttr(e) {
			if(this.srQcInput.mrp == "")
			{
				 return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.falsyProduct == false) {
				var code = (e.keyCode || e.which);
				// do nothing if it's an arrow key
				if (code == 37 || code == 38 || code == 39 || code == 40) {
					return;
				}
				this.mrpError = "";
				this.isProductAttrFound = false;
				if (this.srQcInput.mrp != '' && this.srQcInput.mrp.length > 2) {
					if (this.isNumeric(this.srQcInput.mrp) === false) {
						this.mrpError = this.$t('srqc.numberMrpError');
						return;
					}

					var inputs = {
						'clientid': this.clientid,
						'orderid': this.srQcDetails.orderid,
						'productid': this.srQcInput.productid,
						'mrp': this.srQcInput.mrp,
						'srid': this.srQcDetails.srid
					}
					// axios.post(apiUrl.api_url + 'getProductDR', inputs,
					//     headers: {
					//       'Authorization': 'Bearer ' + myStr,
					//     }
					//   )
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getProductDR',
							'data': inputs,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})
						.then((response) => {

							if (response.data.errorCode == 0) {
								this.isProductAttrFound = true;
								var drResult = response.data.data;

								// Lopping here to assign DR Number
								var i = 0;
								for (i = 0; i < drResult.length; i++) {
									if (drResult[i].leftqty == 0) {
										continue;
									} else {
										this.srQcInput.drnum = drResult[i].drnum;
										this.srQcInput.expiryDate = drResult[i].expirydate;
										break;
									}
								}
							} else {
							//	this.mrpError = response.data.msg;
								this.isProductAttrFound = false;
							}
						});
				}
			} else {
				//this.srQcInput.drnum = this.clientid.toString();
				var inputs = {
					'clientid': this.clientid,
					'productid': this.srQcInput.productid,
					'mrp': this.srQcInput.mrp,
					'warehouseid' : this.warehouseid,
				};
				//console.log(inputs);return false;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getProductDRExtra',
						'data': inputs,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then((response) => {

						if (response.data.errorCode == 0) {
							this.isProductAttrFound = true;
							var drResult = response.data.data;

							// Lopping here to assign DR Number
							var i = 0;
							for (i = 0; i < drResult.length; i++) {
								if (drResult[i].leftqty == 0) {
									continue;
								} else {
									this.srQcInput.drnum = drResult[i].drnum;
									this.srQcInput.expiryDate = drResult[i].expirydate;
									break;
								}
							}
						} else {
						//	this.mrpError = response.data.msg;
							this.isProductAttrFound = false;
						}
					});

			}
		},

		drSelected() {

		},
		createGoogleLink(imageLink) {
			var preURL = 'https://drive.google.com/uc?export=view&id=';
			var validUrl = '';
			var tempUrl = imageLink.split('?id=');
			if (tempUrl.length == 1) {
				var tempURL = imageLink.split('https://drive.google.com/file/d/');
				var tempURL1 = tempURL[1].split('/view');
				var validUrl = preURL + tempURL1[0];
				this.productimage = validUrl;
			} else {
				validUrl = preURL + tempUrl[1];
				this.productimage = validUrl;
			}

		},
		getRejectReason() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: 0,
				limit: 10,
				warehouseid: this.warehouseid,
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSRRejectReason',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.rejectList = result.data.rows

				}, error => {
					console.error(error)
				})
		},

		setRejectFlag() {

			if (this.srQcInput.qualityCheck == "accept") {
				this.reasonflag = false;
				this.srQcInput.rejectreason = '';
				this.srQcInput.rejectreasonother=""
				this.showreasonother = false;
			} else {
				this.getRejectReason();
				this.reasonflag = true;
			}
			this.rejectOtherError = '';
		},

		daysInMonth(year, month) {
			return new Date(year, month + 1, 0).getDate();
		},
		addMonths(date, months) {
			var target_month = parseInt(date.getMonth()) + parseInt(months);
			var year = parseInt(date.getFullYear()) + parseInt(target_month / 12);
			var month = target_month % 12;
			var day = date.getDate();
			var last_day = this.daysInMonth(year, month);
			if (day > last_day) {
				day = last_day;
			}
			var new_date = new Date(year, month, day);
			return new_date;
		},

		formattedDate(d) {
			let month = String(d.getMonth() + 1);
			let day = String(d.getDate());
			const year = String(d.getFullYear());

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			//return `${day}/${month}/${year}`;
			return `${year}-${month}-${day}`;

		},

		calculateExpiryDate() {

			if (this.srQcInput.manufacturedDate == "") {
				this.$alertify.error(this.$t('srqc.manufacturedDateError'));
				this.srQcInput.expiryDate = '';
				return false;
			} else if (this.srQcInput.shelflife == "" || this.srQcInput.shelflife == 0) {
				this.srQcInput.expiryDate = '';
				return false;
			} else {
				var dt = this.dateFormat1(this.srQcInput.manufacturedDate);
				var endDate = this.formattedDate(this.addMonths(new Date(dt), this.srQcInput.shelflife));
				this.srQcInput.expiryDate = new Date(endDate);
			}

		},

		saveSrQc(scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {

				} else {
					return false;
				}
			});
		},
		resetOtherReason(){

			if(this.srQcInput.rejectreasonother != ''){
			this.rejectOtherError = false;}
			else{
				this.rejectOtherError = true;
			}
			console.log("sas")
		},
		saveProductQCSR(scope) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.srQcInput.couriername == "") {
				this.couriernameerror = this.$t('srqc.transporterError')
				return false;
			}
			if (this.srQcInput.mrp == "") {
				return false;
			}
			if (this.srQcInput.manufacturedDate == "" && this.isExpiryControl == 1) {
				return false;
			}
			if (this.srQcInput.expiryDate == "" && this.srQcInput.shelflife == "" && this.isExpiryControl == 1) {
				this.$alertify.error(this.$t('srqc.expiryError'));
				return false;
			}
			if (this.srQcInput.lotNumber == "" && this.isLotControl == 1) {
				return false;
			}
			if (this.srQcInput.qualityCheck == "") {
				this.$alertify.error(this.$t('srqc.qualityCheckError'));
				return false;
			}
			if (this.reasonflag == true && this.srQcInput.rejectreason == "") {
				this.$alertify.error(this.$t('srqc.rejectReasonListError'));
				return false;
			}
			if(this.srQcInput.rejectreason == "other" && this.srQcInput.rejectreasonother == "")
			{
				 this.rejectOtherError = true;
				 return false;
			}


			if (this.isProductAttrFound == false && this.falsyProduct == false) {
				this.$alertify.error(this.$t('srqc.mrpError'));
				return false;
			}
			// Now validating the Manufactured & Expiry Date
			if (this.isExpiryControl == 1 && (this.srQcInput.expiryDate < this.srQcInput.manufacturedDate)) {
				this.$alertify.error(this.$t('srqc.expiryManufactureError'));
				return false;
			}
			if (this.isExpiryControl == "" || this.isExpiryControl == null) {
				this.isExpiryControl = 0
			}
			this.rejectOtherError = false;
			this.input = ({
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				useremail: this.useremail,
				productid: this.finalproductid,
				srid: this.srQcDetails.srid,
				mrp: this.srQcInput.mrp,
				manufacturedDate: this.dateFormat1(this.srQcInput.manufacturedDate),
				expirydate: this.dateFormat1(this.srQcInput.expiryDate),
				lotcontrol: this.srQcInput.lotNumber,
				qualityCheck: this.srQcInput.qualityCheck,
				rejectReason: (this.srQcInput.rejectreason != 'other') ? this.srQcInput.rejectreason : this.srQcInput.rejectreasonother,
				awbnumber: this.srQcInput.AWBNo,
				comment: this.srQcInput.comment,
				drnumber: this.srQcInput.drnum,
				isExpiryControl: this.isExpiryControl,
				isLotControl: this.isLotControl,
				//closelpn: this.srQcInput.closelpn,
				validProduct: this.falsyProduct,

			});
      //console.log(this.input);return false;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveQcSr',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.resultData = result.data;
					if (this.resultData.errorCode == 0) {
						this.srQcInput.AWBNo = '';
						this.getElementByIdFn('AWBNo', '');
						this.resetform();
						this.isAwbFound = false;
						this.isExpiryControl = 0;
						this.isProductFound = false;
						this.isLotControl = false;
						this.srQcInput.productid = '';
						this.srQcInput.mrp = '';
						this.srQcInput.shelflife = '';
						this.srQcInput.manufacturedDate = '';
						this.srQcInput.expiryDate = '';
						this.srQcInput.lotNumber = '';
						this.srQcInput.qualityCheck = '';
						this.srQcInput.rejectreason = '';
						this.srQcInput.couriername = '';
						this.srQcInput.comment = '';
						this.srQcInput.drnum = '';
						this.srQcInput.closelpn = false;
						this.isProductAttrFound = false;
						this.srQcInput.rejectreasonother= '';
						this.getElementByIdFn('AWBNo', '');
						this.$alertify.success(this.resultData.msg);
					} else {
						this.$alertify.error(this.resultData.msg);
					}

				}, error => {
					console.error(error)
				})
			console.log(this.input);

		},


		getElementByIdFn(elmId, val) {
			document.getElementById(elmId).value = val;
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/sr/srqc/srqc.component.js